module.exports = __webpack_public_path__ + "images/fb9b0d1a8639ecd53a6d38c57bc5656e.png";